module.exports = __webpack_public_path__ + "img/59_7.b822a4e7.png";